var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MainLayout',[_c('b-card',[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('h3',{staticClass:"m-0"},[_vm._v("Dashboard")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }